export const LICENSE_RESET_STATE = 'LICENSE_RESET_STATE';
export const LICENSE_CURRENT_ITEM = 'LICENSE_CURRENT_ITEM';

export const LICENSE_REQUEST_LOADING = 'LICENSE_REQUEST_LOADING';
export const LICENSE_REQUEST_SUCCESS = 'LICENSE_REQUEST_SUCCESS';
export const LICENSE_REQUEST_FAILED = 'LICENSE_REQUEST_FAILED';

export const LICENSE_CURRENT_ACTION = 'LICENSE_CURRENT_ACTION';
export const LICENSE_RESET_ACTION = 'LICENSE_RESET_ACTION';